<template>
  <transition name="no-mode-fade">
    <div
      class="tab-pane fade show active"
      id="home"
      role="tabpanel"
      aria-labelledby="home-tab"
    >
      <div class="row mb-3 mt-3">
        <div class="col-md-3">
          <b-button-group v-if="user.account_type != 'student'">
            <b-button variant="outline-danger">
              <input
                type="checkbox"
                v-model="selectAll"
                @change="selectItemAll(selectAll)"
              />
            </b-button>
            <b-button
              variant="outline-danger"
              type="button"
              :disabled="recordIds.length == 0"
              @click="multiDelete" v-if="$role=='super_admin'"
            >
              <i class="fa fa-trash"></i>
              {{ $t("site.bulk_delete") }}
            </b-button>
          </b-button-group>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input
              type="text"
              autofocus
              class="form-control"
              v-model="search"
              @input="(val) => searchChange(val)"
              :placeholder="$t(`site.search`)"
            />
          </div>
        </div>
        <div class="col-3">
          <div class="float-md-right pt-1">
            <span class="text-muted text-small mr-1 mb-2"
              >{{ from }}:{{ to }}
            </span>

            <b-dropdown
              id="ddown2"
              right
              :text="`${perPage}`"
              variant="outline-warning"
              size="xs"
            >
              <b-dropdown-item
                v-for="(size, index) in [5, 10, 20, 50, 100]"
                :key="index"
                @click="changePageSize(size)"
                >{{ size }}</b-dropdown-item
              >
            </b-dropdown>
            <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
          </div>
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->

      <!-- end of row -->

      <div class="row">
        <div class="col-md-12">
          <b-table :stacked="($mobile==1)" 
            ref="table"
            class="vuetable"
            sort-by="id"
            sort-desc.sync="false"
            :current-page="currentPage"
            :fields="bootstrapTable.fields"
            :items="dataProvider"
          >
            <template #cell(priority)="data">
              <b-avatar variant="light-danger" v-if="data.item.priority == 1">
                <span> {{ $t("announcements.priority_high") }}</span>
              </b-avatar>
              <b-avatar variant="light-warning" v-if="data.item.priority == 2">
                <span style="font-size: smaller">
                  {{ $t("announcements.priority_medium") }}</span
                >
              </b-avatar>
              <b-avatar
                variant="light-secondary"
                v-if="data.item.priority == 3"
              >
                <span style="font-size: smaller">
                  {{ $t("announcements.priority_low") }}</span
                >
              </b-avatar>
            </template>
            <template #cell(target)="data">
              <b-badge variant="info">
                {{ $t(`announcements.${data.item.target}`) }}
              </b-badge>
            </template>
            <template #cell(edit)="data">
              <button v-if="user.account_type != 'student'"
                class="btn btn-icon btn-warning btn-sm"
                @click="editItem(data)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button  
                type="submit"
                class="btn btn-icon btn-danger btn-sm delete"
                 @click="deleteItem(data)" v-if="$role=='super_admin'"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
            <template #cell(checkbox)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
                <input
                  type="checkbox"
                  v-model="select[data.index]"
                  @change="selectItem(data, select[data.index])"
                />
                <span></span>
              </label>
            </template>
          </b-table>

          <hr />
          <b-pagination
            align="right"
            class="dataTables_paginate paging_simple_numbers pagination-warning"
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
          >
            <template v-slot:next-text>
              <i class="fas fa-angle-left" />
            </template>
            <template v-slot:prev-text>
              <i class="fas fa-angle-right" />
            </template>
            <template v-slot:first-text>
              <i class="fas fa-step-forward" />
            </template>
            <template v-slot:last-text>
              <i class="fas fa-step-backward" />
            </template>
          </b-pagination>

          <!-- end of table -->
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->
    </div>
  </transition>
</template>

<script>
import controller from "../../../../Controllers/MasterAnnouncementsController";
import config from "../../../../config/config";
import Auth from "@/Apis/Auth";
let ctx = new controller();
export default {
  props: ["items", "editItem"],
  data() {
    return {
      user: Auth.USER,

      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "title",
            label: this.$i18n.t("announcements.title"),
            sortable: true,
          },
          {
            key: "type",
            label: this.$i18n.t("announcements.type"),
            sortable: true,
          },
          {
            key: "priority",
            label: this.$i18n.t("announcements.priority"),
            sortable: true,
          },
          {
            key: "publish_date",
            label: this.$i18n.t("announcements.publish_date"),
            sortable: true,
          },
          {
            key: "expiry_date",
            label: this.$i18n.t("announcements.expiry_date"),
            sortable: true,
          },
          {
            key: "target",
            label: this.$i18n.t("announcements.target"),
            sortable: true,
          },
          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
    };
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ct) {
      this.load = true;
      this.params = ct;
      const data = await ctx.GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      const items = data.data;
      this.load = false;
      return items;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      if (Auth.USER.account_type != "admin") apiParams.userId = Auth.USER.id;
       apiParams.master = 1;
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItem(val, select) {
      if (select) {
        this.recordIds.push(val.item.id);
      } else {
        const index = this.recordIds.indexOf(val.item.id);
        if (index !== -1) {
          this.recordIds.splice(index, 1);
        }
      }
    },
    selectItemAll(select) {
      console.log(select);
    },
    deleteItem(data) {
      ctx.Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      ctx.Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>

<style></style>